// components/Editor.tsx
import React, { useCallback, useRef, useState } from "react";
import { EditorContent } from "@tiptap/react";
import Bold from "../images/Formatter Icons/format_bold.svg";
import Italic from "../images/Formatter Icons/format_italic.svg";
import indentDecrease from "../images/Formatter Icons/format_indent_decrease.svg";
import indentIncrease from "../images/Formatter Icons/format_indent_increase.svg";
import LeftAlign from "../images/Formatter Icons/format_align_left.svg";
import RightAlign from "../images/Formatter Icons/format_align_right.svg";
import CenterAlign from "../images/Formatter Icons/format_align_center.svg";

import Justify from "../images/Formatter Icons/Justification.svg";
import ColorImage from "../images/Formatter Icons/text_Color.svg";
import Attachment from "../images/Formatter Icons/attach_file.svg";

import Pdf from "../images/DownloadPdf.svg";
import Image from "../images/DownloadImage.svg";
import Doc from "../images/WordDocument.svg";
import Xls from "../images/Excel.svg";
import Close from "../images/Close.svg";

import { Props } from "../components/modules/asset/Meetings/planning/Plan";
import { allowedFormatsForMom } from "../utils/constants";
import { downloadFile } from "../utils/UtilFunctions";
import { Keys } from "../utils/Enum.keys";

const TiptapEditor = ({ commentState, editor, filesState }: Props) => {
  const { comment, setComment } = commentState;
  const { selectedFiles, setSelectedFiles } = filesState;
  const [selectedColor, setSelectedColor] = useState("#000000");
  const inputRef = useRef<HTMLInputElement>(null);

  const handleColorChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const color = e.target.value;
    setSelectedColor(color);
    if (editor) {
      editor.chain().focus().setColor(color).run();
    }
  };

  const clickFileInput = () => {
    const inputFile = document.getElementsByName("attachment-input");
    if (inputFile && inputFile.length > 0) {
      inputFile[0].click();
    }
  };
  const chooseFile = useCallback(
    (file: File, index: number) => {
      const ext = file.name.split(".").pop();
      switch (ext) {
        case "jpg":
        case "jpeg":
        case "png":
          return (
            <div className="bg-grey" onClick={() => downloadFile(file)}>
              {file.name} <img src={Image} alt="not found" />
              <img
                src={Close}
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedFiles((prev) =>
                    prev.filter((f, i) => i !== index)
                  );
                }}
                alt="not found"
              />
            </div>
          );
        case "doc":
        case "docx":
          return (
            <div className="bg-grey" onClick={() => downloadFile(file)}>
              {file.name} <img src={Doc} alt="not found" />
              <img
                src={Close}
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedFiles((prev) =>
                    prev.filter((f, i) => i !== index)
                  );
                }}
                alt="not found"
              />
            </div>
          );
        case "xlsx":
        case "xls":
        case "csv":
          return (
            <div>
              {file.name} <img src={Xls} alt="not found" />
              <img
                src={Close}
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedFiles((prev) =>
                    prev.filter((f, i) => i !== index)
                  );
                }}
                alt="not found"
              />
            </div>
          );
        case "pdf":
          return (
            <div>
              {file.name} <img src={Pdf} alt="not found" />
              <img src={Pdf} alt="not found" />
              <img
                src={Close}
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedFiles((prev) =>
                    prev.filter((f, i) => i !== index)
                  );
                }}
                alt="not found"
              />
            </div>
          );
      }
    },
    [selectedFiles]
  );

  const handleChooseFiles = (e: React.ChangeEvent<HTMLInputElement>) => {
    let filesCannotbeAdded: File[] = [];
    let filesThatCanBeAdded: File[] = [];

    if (e.target.files && e.target.files.length) {
      const files = Array.from(e.target.files);
      files.forEach((file) => {
        if (allowedFormatsForMom.includes(file.name.split(".")[1])) {
          filesThatCanBeAdded.push(file);
        } else {
          filesCannotbeAdded.push(file);
        }
      });
    }
    setSelectedFiles(filesThatCanBeAdded);

    if (filesCannotbeAdded.length) {
      alert(
        `Files ${filesCannotbeAdded
          .map((file) => file.name)
          .join(", ")} cannot be added`
      );
    }
  };

  if (!editor) {
    return null;
  }

  return (
    <div className="tip-tap-editor">
      <EditorContent
        editor={editor}
        className="tip-tap-editor__content"
        value={comment}
      />
      <div className={`tip-tap-editor__attachment`}>
        {selectedFiles
          ? selectedFiles.map((file, index) => chooseFile(file, index))
          : null}
      </div>
      <div className="tip-tap-editor__menu">
        <button
          onClick={() => editor?.chain().focus().toggleBold().run()}
          disabled={!editor?.can().chain().focus().toggleBold().run()}
        >
          <img src={Bold} alt="" />
        </button>
        <button
          onClick={() => editor?.chain().focus().toggleItalic().run()}
          disabled={!editor?.can().chain().focus().toggleItalic().run()}
        >
          <img src={Italic} alt="" />
        </button>
        <button
          onClick={() =>
            editor?.chain().focus().toggleHeading({ level: 1 }).run()
          }
          className={
            editor?.isActive("heading", { level: 1 }) ? "is-active" : ""
          }
        >
          h1
        </button>
        <button
          onClick={() =>
            editor?.chain().focus().toggleHeading({ level: 2 }).run()
          }
          className={
            editor?.isActive("heading", { level: 2 }) ? "is-active" : ""
          }
        >
          h2
        </button>
        <button
          onClick={() =>
            editor?.chain().focus().toggleHeading({ level: 3 }).run()
          }
          className={
            editor?.isActive("heading", { level: 3 }) ? "is-active" : ""
          }
        >
          h3
        </button>
        <button onClick={() => editor?.chain().focus().setParagraph().run()}>
          P
        </button>
        {/* <button
          onClick={() => editor?.chain().focus().toggleBulletList().run()}
        >
          <img src={BulletListImage} alt="" />{" "}
        </button>
        <button
          onClick={() => editor?.chain().focus().toggleOrderedList().run()}
        >
          <img src={OrderedLisImage} alt="" />{" "}
        </button> */}
        <button
          onClick={() => editor?.chain().focus().sinkListItem("listItem").run()}
        >
          <img src={indentIncrease} alt="" />{" "}
        </button>
        <button
          onClick={() => editor?.chain().focus().liftListItem("listItem").run()}
        >
          <img src={indentDecrease} alt="" />{" "}
        </button>
        {/* <button
          onClick={() => editor?.chain().focus().toggleStrike().run()}
          className={editor?.isActive("strike") ? "is-active" : ""}
        >
          <img src={Strike} alt="" />
        </button> */}

        <button
          onClick={() => editor?.chain().focus().setTextAlign("left").run()}
          className={editor?.isActive({ textAlign: "left" }) ? "is-active" : ""}
        >
          <img src={LeftAlign} alt="" />
        </button>
        <button
          onClick={() => editor?.chain().focus().setTextAlign("center").run()}
          className={
            editor?.isActive({ textAlign: "center" }) ? "is-active" : ""
          }
        >
          <img src={CenterAlign} alt="" />
        </button>
        <button
          onClick={() => editor?.chain().focus().setTextAlign("right").run()}
          className={
            editor?.isActive({ textAlign: "right" }) ? "is-active" : ""
          }
        >
          <img src={RightAlign} alt="" />{" "}
        </button>

        <button
          onClick={() => editor?.chain().focus().setTextAlign("justify").run()}
          className={
            editor?.isActive({ textAlign: "justify" }) ? "is-active" : ""
          }
        >
          <img src={Justify} alt="" />{" "}
        </button>
        <button
          onClick={() => editor?.chain().focus().setTextAlign("justify").run()}
          className={
            editor?.isActive({ textAlign: "justify" }) ? "is-active" : ""
          }
        >
          <img src={Justify} alt="" />{" "}
        </button>

        <button
          onClick={() => {
            clickFileInput();
          }}
          className={
            editor?.isActive({ textAlign: "justify" }) ? "is-active" : ""
          }
        >
          <img src={Attachment} alt="" />{" "}
        </button>
        <input
          type="color"
          value={selectedColor}
          onChange={handleColorChange}
          className="tip-tap-editor__menu--color-picker"
          ref={inputRef}
        />
        <img
          src={ColorImage}
          alt=""
          onClick={() => inputRef.current?.click()}
        />
        <input
          type="file"
          name="attachment-input"
          multiple
          accept={allowedFormatsForMom.join(", ")}
          onChange={handleChooseFiles}
          className="tip-tap-editor__menu--input-attachment"
        />
      </div>
    </div>
  );
};

export default TiptapEditor;
